import { VideoModal } from '../components/video_modal.js';

export class NodePageArticle extends DrupalBehavior {
  onContent(context) {
    context.querySelectorAll('iframe').forEach((iframe) => {
      iframe.addEventListener('load', () => {
        iframe.style.opacity = '1';
      });
    });

    var videoModal = new VideoModal();
    var videos = context.querySelectorAll('.article--teaser--video');
    videoModal.init(videos);

    const share = context.querySelector('.article--header .share');
    if (share) {
      gsap.registerPlugin(ScrollTrigger);
      const container = document.querySelector('main.main');

      ScrollTrigger.create({
        trigger: container,
        start: 'top top+=150px',
        end: 'bottom bottom',
        onToggle: ({ progress, direction, isActive }) => {
          if (isActive) {
            share.classList.add('visible');
          } else {
            share.classList.remove('visible');
          }
        },
      });
    }
  }
}

DrupalBehavior.register('rush_theme.node_page', 'article', NodePageArticle);
